import React from 'react';
import { useNavigate } from 'react-router-dom';
import PanchTatvaButton from '../components/PanchTatvaButton';

const Section = ({ title, children }) => (
  <div className="mb-8 md:mb-10">
    <h2 className="text-xl md:text-2xl font-heading text-headingText mb-3 md:mb-4">{title}</h2>
    <div className="text-sm md:text-base text-bodyText leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function TermsOfService() {
  const navigate = useNavigate();
  return (
    <div className="w-full max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-20">
      {/* Header */}
      <div className="text-center mb-10 md:mb-14">
        <p className="text-secondary font-medium tracking-widest text-xs md:text-sm uppercase mb-3">Legal</p>
        <h1 className="text-3xl md:text-5xl font-heading text-headingText mb-4">Terms of Service</h1>
        <p className="text-sm text-bodyText opacity-70">Last updated: March 22, 2026</p>
      </div>

      <div className="bg-cardBg rounded-2xl p-6 md:p-10 shadow-sm">

        <Section title="1. Acceptance of Terms">
          <p>
            By accessing or purchasing from Panch Tatva by Anukta, you agree to be bound by these Terms of
            Service. If you do not agree, please refrain from using our website or placing orders.
          </p>
        </Section>

        <Section title="2. About Us">
          <p>
            "Panch Tatva by Anukta" is a brand and philosophy operated by <strong>Anukta Panchatatva LLP</strong>,
            registered in India. We create handcrafted elemental wellness products inspired by the five
            elements — Earth, Water, Fire, Air, and Ether.
          </p>
        </Section>

        <Section title="3. Products & Pricing">
          <p>All product descriptions, prices, and availability are subject to change without notice.</p>
          <p>Prices are listed in Indian Rupees (₹) and are inclusive of applicable GST unless stated otherwise.</p>
          <p>We reserve the right to refuse or cancel any order at our discretion.</p>
        </Section>

        <Section title="4. Orders & Payments">
          <p>
            Orders are confirmed only upon successful payment. We accept payments via Razorpay, which supports
            UPI, credit/debit cards, net banking, and wallets.
          </p>
          <p>
            In case of payment failure, no amount is deducted. If a deduction occurs without order confirmation,
            it will be refunded within 5–7 business days.
          </p>
        </Section>

        <Section title="5. Intellectual Property">
          <p>
            All content on this website — including text, images, product names, and the Panch Tatva philosophy —
            is the exclusive intellectual property of Anukta Panchatatva LLP. Reproduction without written consent
            is prohibited.
          </p>
        </Section>

        <Section title="6. Limitation of Liability">
          <p>
            Panch Tatva by Anukta shall not be liable for any indirect, incidental, or consequential damages
            arising from the use of our products or website. Our maximum liability is limited to the amount paid
            for the specific order.
          </p>
        </Section>

        <Section title="7. Governing Law">
          <p>
            These terms are governed by the laws of India. Any disputes shall be subject to the exclusive
            jurisdiction of courts in Noida, Uttar Pradesh, India.
          </p>
        </Section>

        <Section title="8. Contact">
          <p>
            For legal queries, write to us at{' '}
            <a href="mailto:support@panch-tatva.co.in" className="text-secondary hover:underline">
              support@panch-tatva.co.in
            </a>
          </p>
        </Section>

      </div>

      <div className="mt-10 text-center">
        <PanchTatvaButton onClick={() => navigate(-1)} variant="outline">
          ← Go Back
        </PanchTatvaButton>
      </div>
    </div>
  );
}
